import React, { ChangeEvent } from 'react';
import { FormGroup, FormControlLabel, Checkbox, styled } from '@material-ui/core';
import DMToolTip from '../Tooltip/DMToolTip';

const StyledFormGroup = styled(FormGroup)({
  display: 'block',
  textAlign: 'right',
});

export type LabeledCheckboxProps = {
  checked?: boolean;
  label: string;
  tooltipMessage?: string;
  hideOnPrint?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  disableTooltip?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const LabeledCheckbox: React.FC<LabeledCheckboxProps> = ({
  checked,
  label,
  hideOnPrint = () => {},
  tooltipMessage,
  disabled = false,
  disableTooltip,
  ...restProps
}) => (
  <StyledFormGroup {...restProps}>
    {!disableTooltip ? (
      <DMToolTip message={tooltipMessage || ''} placement="bottom-start">
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={checked}
              onChange={hideOnPrint}
              size="small"
              disabled={disabled}
            />
          }
          label={label}
        />
      </DMToolTip>
    ) : (
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            checked={checked}
            onChange={hideOnPrint}
            size="small"
            disabled={disabled}
          />
        }
        label={label}
      />
    )}
  </StyledFormGroup>
);

export default LabeledCheckbox;
